// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3-BvJ","title":"Images45_title__fJjF4","images":"Images45_images__gy6VW"};